import Screen from './Screen'

export default class Screens {

  constructor (array) {

    this.entryScreenId = array[0].id

    this.screens = {}
    for (let screen of array) {
      this.screens[screen.id] = new Screen(screen)
    }
  }

  screen (screenId) {
    if (screenId) {
      return this.screens[screenId]
    } else {
      return this.screens[this.entryScreenId]
    }
  }


  lastestScreenId (values, entryScreenId) {
    let screen = this.screen(entryScreenId)

    while (screen) {
      let [stateId, screenId] = screen.entryState(values)
    
      if (screenId) {
        screen = this.screen(screenId)
        if (!screen) {
          return screenId
        }
      }

      while (stateId) {
        let state = screen.states[stateId]
        let v = values[state.qid]
        let [nextStateId, nextScreenId] = state.nextStateIdAndScreenId(v, values)
    
        stateId = nextStateId
        if (stateId == null) {
          if (nextScreenId) {
            screen = this.screen(nextScreenId)
            if (!screen) {
              return nextScreenId
            }
          } else {
            return screen.id
          }
        }        
      }

    }

    return screen.id

  }

  screenPath (values, entryScreenId) {
    let screenPath = []

    
    let screen = this.screen(entryScreenId)
    while (screen) {

      let [stateId, screenId] = screen.entryState(values)

      // jump directly to next screen if redirected
      if (screenId) {
        screen = this.screen(screenId)
        if (screen == null) {
          break
        }  
      } else {
        screenPath.push(screen)
      }
         
              
      while (stateId) {
        let state = screen.states[stateId]
        let v = values[state.qid]
        let [nextStateId, nextScreenId] = state.nextStateIdAndScreenId(v, values)

        stateId = nextStateId
        if (stateId == null) {
          screen = nextScreenId != null ? this.screen(nextScreenId) : null
        }
        
      }
    }
    return screenPath
  }



}



// WEBPACK FOOTER //
// ./src/model/Screens.js